import { Get, Post, PostFormData, Put,Delete } from "../Request/Api";

export default {
  state: {
    IsOriginalCart:null,
    storeDetailId:null,
    Products: [],
    Product: null,
    CartItems: [],
    ProductCategories: [],
    GetOrders: [],
    userPurchaseAndBillings: [],
    allStoreProductCategory: [],
    catFilter: "",
  },
  getters: {
    getUserPurchaseAndBillings(state: any) {
      return state.userPurchaseAndBillings;
    },
    GetProducts(state: any) {
      return state.Products;
    },
    GetProduct(state: any) {
      return state.Product;
    },
    GetCartItems(state: any) {
      return state.CartItems;
    },
    GetOrders(state: any) {
      return state.GetOrders;
    },
    GetProductCategories(state: any) {
      return state.ProductCategories;
    },
    GetAllStoreProductCategory(state: any){
      return state.allStoreProductCategory;
    }
  },
  actions: {
    async GetProducts({ commit }: any, payload: any) {
      return await Get(
        `Store/GetStoreProducts?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetProducts", res.data.Data?.List);

        return res.data.Data;
      });
    },
    async ProcessPayment({ commit }: any, payload: any) {
      return await Post("Store/ProcessPayment", payload).then((res: any) => {
        return res.data;
      });
    },
    async GetCartItems({ commit }: any, payload: any) {
      var param = "";
      if (payload.UserId != null && payload.UserId != undefined) {
        param += `UserId=${payload.UserId}`;
      }
      if (payload.GuestId != null && payload.GuestId != undefined) {
        param += `GuestId=${payload.GuestId}`;
      }
      return await Get(`Store/GetCartItems?${param}&IsOriginalCart=${payload.IsOriginalCart}`).then((res: any) => {
        commit("SetCartItems", res.data.Data);

        return res.data.Data;
      });
    },
    async AddToCart({ commit }: any, payload: any) {
      return await Post("Store/AddToCart", payload).then((res) => {
        return res.data;
      });
    },
    async SyncGuestCartToUser({ commit }: any, payload: any) {
      return await Post("Store/SyncGuestCartToUser", payload).then((res) => {
        return res.data;
      });
    },
    
    async BecomeInstructorCheckout({ commit }: any, payload: any) {
      return await Post("Store/InstructorCheckout", payload).then((res) => {
        return res.data;
      });
    },
    async IncreaseCartItem({ commit }: any, payload: any) {
      return await Put("Store/IncreaseCartItem", payload).then((res) => {
        return res.data;
      });
    },
    async DecreaseCartItem({ commit }: any, payload: any) {
      return await Put("Store/DecreaseCartItem", payload).then((res) => {
        return res.data;
      });
    },
    async DeleteCartItemById({ commit }: any, payload: any) {
      return await Delete(`Store/DeleteCartItemById?Id=${payload}`).then((res) => {
        return res.data;
      });
    },
    async GetProductById({ commit }: any, payload: any) {
      return await Get(
        `Store/GetStoreProductsById?Id=${payload}&Web=true`
      ).then((res: any) => {
        commit("SetProduct", res.data.Data);

        return res.data.Data;
      });
    },
    async GetStoreProductCategory({ commit }: any, payload: any) {
      return await Get(`Store/GetStoreProductCategory`).then((res: any) => {
        commit("SetProductCategory", res.data.Data);

        return res.data.Data;
      });
    },
    async GetOrders({ commit }: any, payload: any) {
      var param = "";
      if (payload.UserId != null && payload.UserId != undefined) {
        param += `UserId=${payload.UserId}`;
      }
      if (payload.GuestId != null && payload.GuestId != undefined) {
        param += `GuestId=${payload.GuestId}`;
      }
      return await Get(`Store/GetOrders?${param}`).then((res: any) => {
        commit("SetGetOrders", res.data.Data);

        return res.data.Data;
      });
    },
    async GetUserPurchaseAndBillings({ commit }: any, payload: any) {
      return await Get(`User/GetUserPurchaseAndBillings?UserId=${payload.id}`).then((res: any) => {
        commit("SetUserPurchaseAndBillings", res.data.Data);
        return res.data.Data;
      });
    },
    async GetAllStoreProductCategory({ commit }:any, payload: any) {
      return await Get("Store/GetAllStoreProductCategory").then((res: any) => {
        commit("SetAllStoreProductCategories", res.data.Data);
        return res.data;
      });
    },
  },
  mutations: {
    SetAllStoreProductCategories(state: any, payload: any){
        state.allStoreProductCategory = payload
    },
    SetUserPurchaseAndBillings(state: any, payload: any){
      state.userPurchaseAndBillings = payload
    },
    SetProductCategory(state: any, payload: any) {
      state.ProductCategories = payload;
    },
    SetProducts(state: any, payload: any) {
      payload = payload?.map((x: any) => {
        x.CoverImage =
          x?.CoverImage != null &&
          x?.CoverImage != undefined &&
          x?.CoverImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.CoverImage
            ? x?.CoverImage
            : x?.CoverImage;
        x.Image1 =
          x.Image1 != null && x.Image1 != undefined && x.Image1 != ""
            ? x.Image1
            : x.Image1;
        x.Image2 =
          x.Image2 != null && x.Image2 != undefined && x.Image2 != ""
            ? x.Image2
            : x.Image2;
        x.Image3 =
          x.Image3 != null && x.Image3 != undefined && x.Image3 != ""
            ? x.Image3
            : x.Image3;
        x.Image4 =
          x.Image4 != null && x.Image4 != undefined && x.Image4 != ""
            ? x.Image4
            : x.Image4;
        return x;
      });
      state.Products = payload;
    },
    SetCartItems(state: any, payload: any) {
      payload = payload?.map((x: any) => {
        x.Product.CoverImage =
          x.Product?.CoverImage != null &&
          x.Product?.CoverImage != undefined &&
          x.Product?.CoverImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.Product.CoverImage
            ? x.Product?.CoverImage
            : x.Product?.CoverImage;
        return x;
      });
      state.CartItems = payload;
    },
    SetGetOrders(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.Items = x.Items.map((y: any) => {
          y.Product.CoverImage =
            y.Product?.CoverImage != null &&
            y.Product?.CoverImage != undefined &&
            y.Product?.CoverImage != ""
              // ? process.env.VUE_APP_IMG_URL + "/" + y.Product.CoverImage
              ? y.Product?.CoverImage
              : y.Product?.CoverImage;
          return y;
        });

        return x;
      });
      state.GetOrders = payload;
    },
    SetProduct(state: any, payload: any) {
      payload.CoverImage =
        payload?.CoverImage != null &&
        payload?.CoverImage != undefined &&
        payload?.CoverImage != ""
          // ? process.env.VUE_APP_IMG_URL + "/" + payload.CoverImage
          ? payload?.CoverImage
          : payload?.CoverImage;
      payload.Image1 =
        payload.Image1 != null &&
        payload.Image1 != undefined &&
        payload.Image1 != ""
          ? payload.Image1
          : payload.Image1;
      payload.Image2 =
        payload.Image2 != null &&
        payload.Image2 != undefined &&
        payload.Image2 != ""
          ? payload.Image2
          : payload.Image2;
      payload.Image3 =
        payload.Image3 != null &&
        payload.Image3 != undefined &&
        payload.Image3 != ""
          ? payload.Image3
          : payload.Image3;
      payload.Image4 =
        payload.Image4 != null &&
        payload.Image4 != undefined &&
        payload.Image4 != ""
          ? payload.Image4
          : payload.Image4;
      payload.RelatedProducts = payload.RelatedProducts.map((y: any) => {
        y.CoverImage =
          y?.CoverImage != null &&
          y?.CoverImage != undefined &&
          y?.CoverImage != ""
            ? y?.CoverImage
            : y?.CoverImage;
        return y;
      });
      state.Product = payload;
    },
  },
};
